export const LedgerDerivationPathType = {
    LedgerLive: 'ledger-live',
    LedgerMew: 'ledger-mew',
};
export const WalletLedger = {
    Ledger: 'ledger',
    LedgerCosmos: 'ledger-cosmos',
    LedgerLegacy: 'ledger-legacy',
};
